/**
 * Applied 필터가 기본값과 다른지(=isDirty) — 필터 「초기화」 버튼 노출 판정.
 *
 * 「삭제 가능한 칩 수(activeCount/배지)」가 아니라 **기본값과의 차이**로 판정해야, 날짜·cascade(연도)처럼
 * 비제거 칩으로 표현되는 변경도 「되돌릴 게 있음」으로 잡힌다(배지엔 안 잡혀도 초기화는 떠야 함).
 * 평면 필터 객체(원시값 + string[] 배열) 가정 — 배열은 길이·순서까지 동등 비교(옵션 순서로 정규화되어 안정).
 */
export function isFiltersDirty<T extends object>(applied: T, defaults: T): boolean {
  const a = applied as Record<string, unknown>;
  const d = defaults as Record<string, unknown>;
  // applied·defaults 키 **합집합** 순회 — default 에 없는 optional 키(예: 선택적 plantId)도 누락 없이 비교.
  for (const key of new Set([...Object.keys(d), ...Object.keys(a)])) {
    const av = a[key];
    const dv = d[key];
    if (Array.isArray(av) && Array.isArray(dv)) {
      if (av.length !== dv.length || av.some((v, i) => v !== dv[i])) return true;
    } else if (av !== dv) {
      return true;
    }
  }
  return false;
}
